import AgeCalculator from 'pages/mini-calculators/calculators/ageCalculator.vue';
import CareCalculator from 'pages/mini-calculators/calculators/careCalculator.vue';
import DependencyMultiplicand from 'pages/mini-calculators/calculators/dependencyMultiplicand.vue';
import Earnings from 'pages/mini-calculators/calculators/earnings.vue';
import LossOfEarnings from 'pages/mini-calculators/calculators/lossOfEarnings.vue';
import InflationCalculator from 'pages/mini-calculators/calculators/inflationCalculator.vue';
import Interest from 'pages/mini-calculators/calculators/Interest.vue';
import InterpolatedMultipliers from 'pages/mini-calculators/calculators/InterpolatedMultipliers.vue';
import LifeExpectancy from 'pages/mini-calculators/calculators/lifeExpectancy.vue';
import LossOfPension from 'pages/mini-calculators/calculators/lossOfPension.vue';
import MiniCalculators from 'pages/mini-calculators/MiniCalculators.vue';
import MesotheliomaPslaCalculator from 'pages/mini-calculators/calculators/mesoCalculator.vue';
import Pension from 'pages/mini-calculators/calculators/pension.vue';
import Period from 'pages/mini-calculators/calculators/periodBetweenTwoDates.vue';
import TableDiscounts from 'pages/mini-calculators/calculators/tableDiscounts.vue';
import RetirementAge from 'pages/mini-calculators/calculators/retirementAge.vue';
import {beforeEnter} from 'services/routingMethods';

export default [
    {
        name: 'mini-calculators',
        path: '/mini-calculators',
        beforeEnter: (to, from, next) => beforeEnter(to, from, next),
        component: MiniCalculators,
        meta: {
            calculatorName: 'dashboard'
        },
        children: [
            {
                name: 'mini-calculators::age-calculator',
                path: 'age-calculator',
                component: AgeCalculator,
                meta: {
                    step: 1,
                    name: 'Age Calculator',
                    calculatorName: 'ageCalculator'
                },
            },
            {
                name: 'mini-calculators::care-calculator',
                path: 'care-calculator',
                component: CareCalculator,
                meta: {
                    step: 1,
                    name: 'Care Calculator',
                    calculatorName: 'careCalculator'
                },
            },
            {
                name: 'mini-calculators::dependency-multiplicand',
                path: 'dependency-multiplicand',
                component: DependencyMultiplicand,
                meta: {
                    step: 1,
                    name: 'Dependency Multiplicand',
                    calculatorName: 'dependencyMultiplicand'
                },
            },
            {
                name: 'mini-calculators::gross-net-earnings',
                path: 'gross-net-earnings',
                component: Earnings,
                meta: {
                    step: 1,
                    name: 'Gross/Net Earnings',
                    calculatorName: 'grossNetEarnings'
                },
            },
            {
                name: 'mini-calculators::gross-net-pension',
                path: 'gross-net-pension',
                component: Pension,
                meta: {
                    step: 1,
                    name: 'Gross/Net Pension',
                    calculatorName: 'grossNetPension'
                },
            },
            {
                name: 'mini-calculators::inflation-calculator',
                path: 'inflation-calculator',
                component: InflationCalculator,
                meta: {
                    step: 1,
                    name: 'Inflation Calculator',
                    calculatorName: 'inflationCalculator'
                },
            },
            {
                name: 'mini-calculators::interest',
                path: 'interest',
                component: Interest,
                meta: {
                    step: 1,
                    name: 'Interest Calculator',
                    calculatorName: 'interest'
                },
            },
            {
                name: 'mini-calculators::interpolated-multipliers',
                path: 'interpolated-multipliers',
                component: InterpolatedMultipliers,
                meta: {
                    step: 1,
                    name: 'Interpolated Multipliers',
                    calculatorName: 'interpolatedMultipliers'
                },
            },
            {
                name: 'mini-calculators::life-expectancy',
                path: 'life-expectancy',
                component: LifeExpectancy,
                meta: {
                    step: 1,
                    name: 'Life Expectancy',
                    calculatorName: 'lifeExpectancy'
                },
            },
            {
                name: 'mini-calculators::loss-of-earnings',
                path: 'loss-of-earnings',
                component: LossOfEarnings,
                meta: {
                    step: 1,
                    name: 'Loss of Earnings',
                    calculatorName: 'LossOfEarnings'
                },
            },
            {
                name: 'mini-calculators::loss-of-pension',
                path: 'loss-of-pension',
                component: LossOfPension,
                meta: {
                    step: 1,
                    name: 'Loss of Pension',
                    calculatorName: 'lossOfPension'
                },
            },
            {
                name: 'mini-calculators::mesothelioma-psla-calculator',
                path: 'mesothelioma-psla-calculator',
                component: MesotheliomaPslaCalculator,
                meta: {
                    step: 1,
                    name: 'Mesothelioma PSLA Calculator',
                    calculatorName: 'mesotheliomaPslaCalculator'
                },
            },
            {
                name: 'mini-calculators::period-between-two-dates',
                path: 'period-between-two-dates',
                component: Period,
                meta: {
                    step: 1,
                    name: 'Period Between Dates',
                    calculatorName: 'periodBetweenTwoDates'
                },
            },
            {
                name: 'mini-calculators::pre-and-post-assessment-discounts',
                path: 'pre-and-post-assessment-discounts',
                component: TableDiscounts,
                meta: {
                    step: 1,
                    name: 'Pre and Post Assessment Discounts',
                    calculatorName: 'preAndPostAssessmentDiscounts'
                },
            },
            {
                path: 'retirement-age',
                component: RetirementAge,
                meta: {
                    step: 1,
                    name: 'Retirement Age Calculator',
                    calculatorName: 'retirementAge'
                },
            },
        ],
    },
];



// WEBPACK FOOTER //
// ./src/pages/mini-calculators/routes.js